import { Stack, Button, Text } from '@mantine/core';
import { BirdyClub } from '../BirdyClub';
import { makeAppointment } from '../../../authenticated/participant/book-in-person/makeAppointment';
import { EventSchemaDto, EventsSchemaDto, FeatureFlag } from '@web/common';
import {
  GoogleAnalyticsEvent,
  useGoogleAnalyticsStore,
} from '../../../../store';
import { useTranslation } from 'react-i18next';
import { isFeatureEnabled } from '../../../../util/ff/isFeatureEnabled';
import { BookingSoonPossible } from '../../../authenticated/participant/onboarding-checklist/BookingSoonPossible';

export const SelectAppointmentStep = ({
  isZurican,
  events,
}: {
  isZurican: boolean;
  events: EventsSchemaDto;
}) => {
  const { t } = useTranslation('quick-enroll');
  const googleAnalyticsStore = useGoogleAnalyticsStore();
  const bookingAllowed = isFeatureEnabled(FeatureFlag.BookingAllowed);

  function book(event: EventSchemaDto) {
    const selectedTeamSlug = event.team.slug;
    const selectedTeamId = event.id;

    googleAnalyticsStore.track(GoogleAnalyticsEvent.Enroll_Appointment);

    makeAppointment(
      selectedTeamSlug,
      event.slug,
      selectedTeamId,
      'MadeAppointmentOverQuickEnroll',
      'Dein Name',
      'Deine E-Mail',
    );
  }
  return !isZurican ? (
    <>
      <Text fw="600" size="16px" lh="24px">
        {t('Step')} 3:
      </Text>

      <Stack gap="8px">
        <Text>{t('SelectAppointment.BookAppointment')}</Text>
        {!bookingAllowed && <BookingSoonPossible />}
        {events.map((event) => (
          <Button
            onClick={() => book(event)}
            key={event.id}
            disabled={isZurican || !bookingAllowed}
          >
            {event.title}
          </Button>
        ))}
      </Stack>
    </>
  ) : (
    <BirdyClub />
  );
};
